var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { store } from "../store/RootStore";
import { TickerHelpers, TimeHelpers } from "../../helpers";
/* istanbul ignore next */
export class DataRetriever {
    constructor(rootStore) {
        this.updateIntervalMs = 1 * 60 * 1000; // 1min by default
        this.store = rootStore;
        this.updateJackpots = this.updateJackpots.bind(this);
        this.getJackpotDataProxy = this.getJackpotDataProxy.bind(this);
        this.jackpotsActivation = this.jackpotsActivation.bind(this);
        setTimeout(this.updateJackpots, this.updateIntervalMs);
    }
    updateJackpots() {
        return __awaiter(this, void 0, void 0, function* () {
            const jackpotIds = this.store.jackpots
                //no need to send won jackpots and ones
                //that didn't get any updates on 'activateFor' step (means that platform returns empty response for wrong or invalid ids)
                .filter(x => !(x.IsWon || x.IsWithoutRealUpdates))
                .map(jackpot => jackpot.id);
            const jackpotData = yield this.getJackpotDataProxy(jackpotIds);
            if (jackpotData) {
                jackpotData.forEach(this.store.updateJackpot);
            }
            ;
            setTimeout(this.updateJackpots, this.updateIntervalMs);
        });
    }
    updateJackpot(jackpotId) {
        return __awaiter(this, void 0, void 0, function* () {
            const jackpotData = yield this.getJackpotDataProxy([jackpotId]);
            if (jackpotData) {
                jackpotData.forEach(this.store.updateJackpot);
            }
            ;
        });
    }
    activateFor(jackpotId, isAvailableCallbackFn, incrementPeriod, incrementValue) {
        var jackpotRes = store.addOrGetJackpot(jackpotId, isAvailableCallbackFn, incrementPeriod, incrementValue);
        if (!jackpotRes.isNew) {
            //some block has already registered this JP so no need to get latest data for now
            //but we have to bubble 'isAvailable' state for parent block (ex superbanner) for proper loading logic
            let isAvailable = !jackpotRes.jackpot.IsWithoutRealUpdates;
            this.store.emitIsAvailableChange(jackpotId, isAvailable);
            return jackpotRes.jackpot;
        }
        this.setDelayedFetch();
        return jackpotRes.jackpot;
    }
    jackpotsActivation() {
        const jackpotIdsWithoutUpdates = this.store.jackpots.filter(jackpot => jackpot.IsWithoutRealUpdates).map(jackpot => jackpot.id);
        this.getJackpotDataProxy(jackpotIdsWithoutUpdates).then(resp => {
            let active = {};
            if (resp && Array.isArray(resp) && resp.length) {
                resp.forEach(jackpotUpdateData => {
                    this.processInitialJackpotData(jackpotUpdateData);
                    active[jackpotUpdateData.id] = jackpotUpdateData.id;
                });
            }
            jackpotIdsWithoutUpdates.forEach(jackpotId => {
                if (!active[jackpotId]) {
                    this.store.emitIsAvailableChange(jackpotId, false);
                }
            });
        }).catch(_ => {
            jackpotIdsWithoutUpdates.forEach(jackpotId => this.store.emitIsAvailableChange(jackpotId, false));
        });
    }
    /* istanbul ignore next */
    processInitialJackpotData(jpData) {
        let hasStarted = Date.fromISO(jpData.startDate).getTime() <= TimeHelpers.getCurrentDateTimeUTC(), isActive = jpData.status === "active", isWon = jpData.status === "won", isAvailable = hasStarted && (isActive || isWon);
        hasStarted && this.store.updateJackpot(jpData);
        isWon && this.store.markJackpotAsWon(jpData.id, jpData.currentValue);
        this.store.emitIsAvailableChange(jpData.id, isAvailable);
        let jpIncConfig = this.getJackpotIncrementConfig(jpData.id);
        let updateStrategy = TickerHelpers.UpdateStrategies.init(jpData.currentValue, jpIncConfig.period, jpIncConfig.value);
        this.simulateUpdateRequest(updateStrategy, jpData.id, jpIncConfig.period, jpIncConfig.value);
    }
    getJackpotIncrementConfig(id) {
        let jp = this.store.jackpots.find(jpItem => jpItem.id === id);
        if (jp && jp.incrementPeriod && jp.incrementValue) {
            return {
                period: jp.incrementPeriod,
                value: jp.incrementValue
            };
        }
        return {
            period: undefined,
            value: undefined
        };
    }
    setDelayedFetch() {
        clearTimeout(this.activationTimeout);
        this.activationTimeout = setTimeout(this.jackpotsActivation, 5);
    }
    simulateUpdateRequest(updateStrategy, jpId, incrementPeriod, incrementValue) {
        let val = updateStrategy.getNextTickerValue();
        let updateResult = this.store.updateJackpotTicker(jpId, val);
        // no result (no jackpot data in store or not valid for update) => no next updates
        if (!updateResult) {
            return;
        }
        //ticker was updated as expected so continue update with new approximate value
        if (updateResult.tickerValue === val) {
            setTimeout(this.simulateUpdateRequest.bind(this), updateStrategy.interval, updateStrategy, jpId, incrementPeriod, incrementValue);
            return;
        }
        //we got diff value than we have sent for 'updateJackpotTicker'
        if (updateResult.needToRequestLatest) {
            //simulation went above maxvalue => try to get latest current value and re-init update logic
            this.getJackpotDataProxy([jpId]).then(latestUpdate => {
                if (!latestUpdate || !latestUpdate.length) {
                    return;
                }
                let jpUpdate = latestUpdate[0];
                //set latest value and invoke simulation from latest value
                this.store.updateJackpotTicker(jpId, jpUpdate.currentValue);
                let newUpdateStrategy = TickerHelpers.UpdateStrategies.init(jpUpdate.currentValue, incrementPeriod, incrementValue);
                setTimeout(this.simulateUpdateRequest.bind(this), newUpdateStrategy.interval, newUpdateStrategy, jpId, incrementPeriod, incrementValue);
            }).catch(err => { });
        }
        else {
            //ticker was updated to the lower value on regular 'updateJackpots' flow
            //so generate new value based on it
            let newUpdateStrategy = TickerHelpers.UpdateStrategies.init(updateResult.tickerValue, incrementPeriod, incrementValue);
            this.simulateUpdateRequest(newUpdateStrategy, jpId, incrementPeriod, incrementValue);
        }
    }
    getJackpotDataProxy(jackpotIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof getJackpotData === "undefined") {
                return undefined;
            }
            return yield getJackpotData(jackpotIds);
        });
    }
}
/* istanbul ignore next */
export const rootDataRetriever = (() => {
    let globalName = "JackpotRootDataRetriever";
    if (window[globalName]) {
        return window[globalName];
    }
    else {
        const retriever = new DataRetriever(store);
        window[globalName] = retriever;
        return retriever;
    }
})();
//# sourceMappingURL=DataRetriever.js.map